import { PayloadAction, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import type { QuestionAssignmentAnswer } from 'domain/question';

export const answersAdapter = createEntityAdapter({
  selectId: (answer: QuestionAssignmentAnswer) => answer.uuid,
});

// The caller's own perspectives on the topic in front of them: loaded once, then kept by their own writes.
export const answersSlice = createSlice({
  name: 'answers',
  initialState: answersAdapter.getInitialState(),
  reducers: {
    clearAnswers: (state) => {
      answersAdapter.removeAll(state);
    },
    answersLoaded: (state, { payload }: PayloadAction<QuestionAssignmentAnswer[]>) => {
      answersAdapter.setAll(state, payload);
    },
    // The server's copy of one perspective after a write to it failed; null when the server has none.
    answerRestored: (state, { payload }: PayloadAction<{ id: string; answer: QuestionAssignmentAnswer | null }>) => {
      if (payload.answer) answersAdapter.setOne(state, payload.answer);
      else answersAdapter.removeOne(state, payload.id);
    },
    addAnswer: (state, { payload }: PayloadAction<QuestionAssignmentAnswer>) => {
      answersAdapter.setOne(state, payload);
    },
    deleteAnswer: (state, { payload }: PayloadAction<string>) => {
      answersAdapter.removeOne(state, payload);
    },
    updateAnswer: (state, { payload }: PayloadAction<{ id: string; changes: Partial<QuestionAssignmentAnswer> }>) => {
      const { id, changes } = payload;
      answersAdapter.updateOne(state, { id, changes });
    },
  },
});

export const { clearAnswers, answersLoaded, answerRestored, addAnswer, updateAnswer, deleteAnswer } =
  answersSlice.actions;
